<div class="navigation__back flex items-center gap-2" (click)="goBack()">
  <app-feature-flag-tabs>
    <ng-container navTabs>
      <ui-icon [size]="18" icon="griddy-chevron-left" class="flex" (click)="goBack()"></ui-icon>
    </ng-container>
    <ui-icon icon="griddy-arrow-left"></ui-icon>
  </app-feature-flag-tabs>
  <span *ngIf="!iconOnly">{{ label ? label : 'Back' }}</span>
</div>
